import React, { Component } from 'react'

// import classes from './ReportDataEntry.scss'
import { updateFilterOptions, extractFilterOptions, updateObject } from '../../../../helpers/utils'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import Grid from '@material-ui/core/Grid'
import PageInfo from '../../../../components/PageInfo/PageInfo'
import { withTranslate } from 'react-redux-multilingual'

class ReportDataEntry extends Component {
  state = {
    filterModalOpen: false,
    filter: {},
    openPreview: false,
    filterControls: {
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        value: '',
        configs: {
          placeholder: this.props.translate('appraisalType'),
          options: []
        },
        required: true
      },
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelGroup'),
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        required: false
      },
      format: {
        label: this.props.translate('format'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('format'),
          options: [
            { value: 'pdf', label: 'PDF' },
            { value: 'xlsx', label: 'Excel' }
          ]
        },
        required: true
      }
    },
    filterOptions: {
      appraisalTypeFilterOptions: this.props.appraisalTypeFilterOptions,
      companyFilterOptions: this.props.companyFilterOptions,
      formFilterOptions: this.props.formFilterOptions,
      levelGroupFilterOptions: this.props.levelGroupFilterOptions,
      orgFilterOptions: this.props.orgFilterOptions
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    let updatedState = { ...state }
    if (
      props.appraisalTypeFilterOptions !== updatedState.filterOptions.appraisalTypeFilterOptions
    ) {
      const appraisalTypeFilter = updatedState.filterControls.appraisal_type_id
      let updatedFilterItem = updateFilterOptions(
        props.appraisalTypeFilterOptions,
        appraisalTypeFilter,
        'appraisal_type_id',
        'appraisal_type_id',
        { name: 'appraisal_type_name', code: 'appraisal_type_code' }
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          appraisal_type_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          appraisalTypeFilterOptions: props.appraisalTypeFilterOptions
        }
      }
    }
    if (props.companyFilterOptions !== updatedState.filterOptions.companyFilterOptions) {
      const companyFilter = updatedState.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' }
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.companyFilterOptions
        }
      }
    }
    if (props.formFilterOptions !== updatedState.filterOptions.formFilterOptions) {
      const formFilter = updatedState.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { form_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.formFilterOptions
        }
      }
    }
    if (props.levelGroupFilterOptions !== updatedState.filterOptions.levelGroupFilterOptions) {
      const levelGroupFilter = updatedState.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.levelGroupFilterOptions
        }
      }
    }
    if (props.orgFilterOptions !== updatedState.filterOptions.orgFilterOptions) {
      const orgFilter = updatedState.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { org_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.orgFilterOptions
        }
      }
    }
    return updatedState
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false,
      openPreview: false
    })
  }

  openFilterModal = () => {
    let filterControls = this.state.filterControls

    Object.entries(filterControls).map((data, key) => {
      let [datakey] = data

      return (filterControls = {
        ...filterControls,
        [datakey]: { ...filterControls[datakey], value: '' }
      })
    })

    this.props.fetchFilter()
    this.props.clearReportDataEntry()
    this.setState({
      filterModalOpen: true,
      filterControls: filterControls,
      openPreview: false,
      filter: []
    })
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    const updatedItem = { ...filterItem, value: filterValue }
    let updatedFilterControls = updateObject(this.state.filterControls, { [itemKey]: updatedItem })
    const filterOptions = extractFilterOptions(updatedFilterControls)

    if (itemKey === 'appraisal_type_id') {
      this.props.fetchCompanyOptions(filterOptions)
      updatedFilterControls = updateObject(updatedFilterControls, {
        company_id: { ...updatedFilterControls.company_id, value: null },
        form_id: { ...updatedFilterControls.form_id, value: null },
        level_group_id: { ...updatedFilterControls.level_group_id, value: null },
        org_id: { ...updatedFilterControls.org_id, value: null }
      })
    } else if (itemKey === 'company_id') {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrganizationOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchOrganizationOptions(filterOptions)
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    // TODO fetch data from server with seleted fliter
    let filter = extractFilterOptions(this.state.filterControls)
    let par = {
      param_appraisal_type: filter?.appraisal_type_id,
      param_company: filter?.company_id,
      param_form: filter?.form_id,
      param_level_group: filter?.level_group_id,
      param_org: filter?.org_id
    }
    let parameters = {}
    Object.entries(par).map(form => {
      let [key, formAttrs] = form

      if (formAttrs !== undefined) {
        parameters = {
          ...parameters,
          [key]: formAttrs
        }
      }
      return form
    })

    let param = {
      appraisal_type_id: filter?.appraisal_type_id,
      parameters: parameters,
      format: filter.format,
      locale: localStorage.getItem('language')
    }
    this.props.reportDataEntry(param)
    this.setState({
      openPreview: true
    })
    this.closeFilterModal()
  }

  render() {
    let formLoading = <Spinner />
    if (!this.props.loading) {
      formLoading = <PleaseFilter />
    }
    return (
      <Aux>
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoading}
        />
        <Alert />
        <Card>
          <CardHeader
            title={
              <Grid container>
                <Grid item xs sm md>
                  <PageInfo pageTranslateKey={'reportDataEntry'} />
                </Grid>
                <Grid item xs sm md={4}>
                  <FilterBar buttonClicked={this.openFilterModal} />
                </Grid>
              </Grid>
            }></CardHeader>
          <CardBody>{formLoading}</CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    loading: state.reportDataEntry.loading,
    filterLoading: state.reportDataEntry.loadingStates,
    success: state.reportDataEntry.success,
    appraisalTypeFilterOptions: state.reportDataEntry.appraisalType,
    companyFilterOptions: state.reportDataEntry.company,
    formFilterOptions: state.reportDataEntry.form,
    levelGroupFilterOptions: state.reportDataEntry.levelGroup,
    orgFilterOptions: state.reportDataEntry.org,
    report: state.reportDataEntry.report
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchFilter: () => {
      dispatch(actions.fetchAppraisalTypeOptionsForAppraisal())
      // dispatch(actions.fetchCompanyOptionsForAppraisal())
      // dispatch(actions.fetchFormOptions())
      // dispatch(actions.fetchLevelGroupOptions())
      // dispatch(actions.fetchOrganizationOptions())
      // dispatch(actions.fetchPositionOptions())
      // dispatch(actions.fetchEmployeeOptions())
    },
    fetchCompanyOptions: filter => dispatch(actions.fetchCompanyOptionsForAppraisal(filter)),
    fetchFormOptions: filter => dispatch(actions.fetchFormOptionsForAppraisal(filter)),
    fetchOrganizationOptions: filter =>
      dispatch(actions.fetchOrganizationOptionsForAppraisal(filter)),
    fetchLevelGroupOptions: filter => dispatch(actions.fetchLevelGroupOptionsForAppraisal(filter)),
    reportDataEntry: filter => dispatch(actions.reportDataEntry(filter)),
    clearReportDataEntry: () => dispatch(actions.clearReportDataEntry())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(ReportDataEntry))
